import React, { useEffect, useState } from 'react';

import CancelOperator from '../../Components/CancelOperator';
import ModalWarn from '../../Components/Modal/Warn/index'

export default function CancelAgencyManager(props) {
    const [ agencyManager, setAgencyManager ] = useState({
        cpf: '',
        name: '',
        organ: '',
        dt_inc: '',
        dt_canc_exp: ''
    });
    const [ regionalManagerList, setRegionalManagerList ] = useState([]);
    const [ loadAgencyManager, setLoadAgencyManager ] = useState(false);
    const [ pageOptions, setPageOptions ] = useState([]);
    const [ page, setPage ] = useState({
        label: "1", value: "1"
    });
    const [ totalFilter, setTotalFilter ] = useState("0");
    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });
    const [ erroMsg, setErroMsg ] = useState([]);
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    useEffect(() => {

        async function loadAssociatedRegionalManagers() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_usuario_cadastrador: props.location.state.result_search.CPF_USUARIO,
                    pagina_atual: 1,
                    qtd_registros: 10
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaGestoresRegionaisAssociadosAoGestor`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(rangePages.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptions(list);
                        setPage({label: "1", value: "1"});
                        setRegionalManagerList(data.gestoresRegionais);
                        setTotalFilter(data.total);
                    });
                } else {
                    console.log('Error request to /gestao/listaGestoresRegionaisAssociadosAoGestor');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }

        if (!loadAgencyManager && props.location.state !== undefined) {
            setAgencyManager({
                cpf: props.location.state.result_search.CPF_USUARIO,
                name: props.location.state.result_search.NOME_USUARIO,
                organ: {
                    value: props.location.state.result_search.CODIGO_ORGAO,
                    label: props.location.state.result_search.NOME_ORGAO
                },
                dt_inc: props.location.state.result_search.DATA_INCLUSAO,
                dt_canc_exp: props.location.state.result_search.DATA_CANCELAMENTO
            });

            setLoadAgencyManager(true);
            loadAssociatedRegionalManagers();
        }
    }, [props, loadAgencyManager, rangePages]);

    const [ isModalConfirmVisible, setModalConfirmVisible ] = useState(false);
    const [ loadingCancel, setLoadingCancel ] = useState(false);
    const [ canceled, setCanceled ] = useState(false);
    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");

    const onChangePaginationConfig = async (ranPag, pag, isRanPag) => {
        setErroMsg(undefined);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_usuario_cadastrador: props.location.state.result_search.CPF_USUARIO,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaGestoresRegionaisAssociadosAoGestor`, requestOptions).then(function(response) {
            if (response.ok) {
                response.json().then(function(data) {
                    const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                    let list = []
                    let obj = {}
                    for(var i = 1; i <= maxPageOption; i++) {
                        obj = {
                            value: String(i),
                            label: String(i)
                        }
                        list.push(obj);
                    }
                    setPageOptions(list);
                    if(isRanPag){
                        setPage({label: "1", value: "1"});
                    }
                    setRegionalManagerList(data.gestoresRegionais);
                    setTotalFilter(data.total);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setErroMsg(data.message)
                    } else {
                        setErroMsg('Houve algum problema no servidor.');
                    }
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setModalInvalidSessionError(true)
                })
            } else {
                console.log('Request error in gestao/listaGestoresRegionaisAssociadosAoGestor BackendBalcao');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    };

    const onSubmitCancel = async () => {

        setLoadingCancel(true);

        const requestOptions = {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                id_usuario_orgao: props.location.state.result_search.ID_USUARIO_ORGAO,
                cpf_gestor_orgao: agencyManager.cpf,
                codigo_orgao: agencyManager.organ.value
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/cancelaGestorOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function() {                    
                    setCanceled(true);
                    setLoadingCancel(false);
                    setModalConfirmVisible(false)
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setMessageError(data.message);
                        setModalError(true);
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                        console.log('Response error in /gestao/cancelaGestorOrgao BackendBalcao');
                    }

                    setLoadingCancel(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingCancel(false);
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingCancel(false);
                console.log('Error request to /gestao/cancelaGestorOrgao');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <CancelOperator
                pageTitle='Cancelar gestor de rede de atendimento'
                confirmationMsg='Tem certeza que deseja cancelar este gestor de rede de atendimento?'
                successMsg='Gestor de rede de atendimento cancelado com sucesso.'
                operator={agencyManager}
                setOperator={setAgencyManager}
                loadOperator={loadAgencyManager}
                isModalConfirmVisible={isModalConfirmVisible}
                setModalConfirmVisible={setModalConfirmVisible}
                loadingCancel={loadingCancel}
                setLoadingCancel={setLoadingCancel}
                canceled={canceled}
                setCanceled={setCanceled}
                modalError={modalError}
                setModalError={setModalError}
                messageError={messageError}
                setMessageError={setMessageError}
                onSubmitCancel={onSubmitCancel}
                history={props.history}
                location={props.location}
                buttonBackRoute='/gerenciarGestoresOrgao'

                tableResultListTitle='Lista de gestores regionais cadastrados pelo gestor de rede de atendimento'
                messageAssociatedWarning='Existem gestores regionais vinculados a este gestor de rede de atendimento. Caso deseje realizar o cancelamento, é necessário substituir este gestor por outro.'
                buttonReplaceRoute='/consultaGestorOrgaoSubstituto'
                onChangePaginationConfig={onChangePaginationConfig}
                totalFilter={totalFilter}
                searchResult={regionalManagerList}
                pageOptions={pageOptions}
                setPage={setPage}
                page={page}
                erroMsg={erroMsg}
                rangePages={rangePages}
                setRangePages={setRangePages}
            />
        </>
    );
}